import { render, staticRenderFns } from "./DeletarMultiplosItensCotacaoPedido.vue?vue&type=template&id=d68dca50"
import script from "./DeletarMultiplosItensCotacaoPedido.vue?vue&type=script&lang=js"
export * from "./DeletarMultiplosItensCotacaoPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports